// MSAL for this app's own registration, set up by createMsalApp in
// @higgins/utils (shared config, API scope, token getter, sign-out). Startup is
// startMsalApp and the header's account is useMsalAccount, both in @higgins/ui.
import { PublicClientApplication } from '@azure/msal-browser';
import { createMsalApp } from '@higgins/utils';

export const { msalInstance, API_SCOPES, getAccessToken, signOut } = createMsalApp((config) => new PublicClientApplication(config), {
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID as string,
});
